module.exports = __webpack_public_path__ + "img/GH.8eabdc19.png";